import * as signalR from "@microsoft/signalr";
import { Http } from "../axios/interceptors";

const configuredSocketHost = String(
  process.env.VUE_APP_SOCKET_HOST || "",
).trim();
const apiDomain =
  process.env.VUE_APP_PRODUCTION == "true"
    ? process.env.VUE_APP_API_URL_PROD
    : process.env.VUE_APP_API_URL_DEV;
const signalRDomain = configuredSocketHost || apiDomain;

export function createSignalRConnection(url) {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${signalRDomain.replace(/\/$/, "")}/${url}`, {})
    .configureLogging(signalR.LogLevel.Information)
    .withAutomaticReconnect() //[0, 2000, 5000, 10000, 30000]
    .build();
}

// export const allNotifications = async (id, page, rows, active) => Http('GET', `/NotificationsRealTime/GetList?idUser=${id}&page=${page}&rows=${rows}${active == true? `&active=true`: active == false? `&active=false`:''}`)
export const allNotifications = async (id, page, rows, active) => {
  if (!id) throw new Error("ID de usuario requerido");
  return Http(
    "GET",
    `/NotificationsRealTime/GetList?idUser=${id}&page=${page}&rows=${rows}${
      active == true ? `&active=true` : active == false ? `&active=false` : ""
    }`,
  );
};
export const updateNotification = async (notification) =>
  Http("PUT", `/NotificationsRealTime/Update`, null, notification);
